module.exports = __webpack_public_path__ + "img/bojana-trajkovska.ee717055.jpg";